import axios from "axios";
import {config as configurations, CONFIG} from "../config";

class BaseService {
  protected http;
  protected configHeaders;
  protected configEnv:CONFIG
  public contentType = "application/json"

  constructor(baseUrl?:any,configHeaders?:any) {
    this.configEnv = configurations;

    this.http = axios.create({
      baseURL: baseUrl,
      timeout: 50000,
    });

    this.configHeaders = configHeaders;
    this.http.interceptors.response.use(
      (response) => response.data,
      (error) => {
        const { response } = error;

        return Promise.reject(error);
      },
    );
  }

  setConfigHeaders = () => {
    const config = {
      headers: {
        "Content-type": this.contentType,
        ...this.configHeaders,
      },
    };

    return config;
  };

  get = (url:any, configHeaders?:any) => {
    return this.http.get(url, { ...this.setConfigHeaders(), ...configHeaders });
  };

  post = (url:any, data:any, configHeaders?:any) => {
    return this.http.post(url, data, {
      ...this.setConfigHeaders(),
      ...configHeaders,
    });
  };
}

export default BaseService;
